export const AuthProviderEnum = {
  email: "password",
  facebook: "facebook.com",
  google: "google.com"
};